import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { LobbyErrors } from 'src/app/core/models/common/lobby-error.model';
import { LobbyErrorCode } from 'src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum';
import { LeadProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-lead/lead-proxy.service';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';


export interface UploadLeadsFileResult {
  isSuccessfull: boolean,
  error: LobbyErrorCode | null,
  overallLeadsCount: number,
  successfullyCreatedLeadsCount: number,
}

@Injectable({
  providedIn: 'root'
})
export class ImportLeadsFromFileService {

  constructor(private readonly leadProxyService: LeadProxyService) { }

  uploadFile$(file: File, injectorId: number | null = null): Observable<UploadLeadsFileResult> {

    return this.leadProxyService.uploadFile$(file, injectorId).pipe(
      throwIfLobbyErrorCode,
      map(dto => {
        return {
          isSuccessfull: true,
          overallLeadsCount: dto.data.overallLeadsCount,
          successfullyCreatedLeadsCount: dto.data.successfullyCreatedLeadsCount,
          error: null
        }
      }),
      catchError(error => {

        console.log('errore', error)

        if (error instanceof LobbyErrors) {
          return of({
            isSuccessfull: false,
            overallLeadsCount: 0,
            successfullyCreatedLeadsCount: 0,
            error: error.errors[0]?.code ?? LobbyErrorCode.MediaParseError
          })
        }

        if (error instanceof HttpErrorResponse) {
          if (error.status === 415)
            return of({
              isSuccessfull: false,
              overallLeadsCount: 0,
              successfullyCreatedLeadsCount: 0,
              error: LobbyErrorCode.MediaTypeUnsupported
            })
        }

        return of({
          isSuccessfull: false,
          overallLeadsCount: 0,
          successfullyCreatedLeadsCount: 0,
          error: LobbyErrorCode.MediaParseError
        })

      })
    )
  }
}
